export default {
  gameBRoute: {
    loadFailed: "Error al cargar",
    saveSuccess: "Guardado exitosamente",
    saveFailed: "Error al guardar",
    opSuccess: "Operación exitosa",
    deleteSuccess: "Eliminado exitosamente",
    deleteConfirm: "¿Eliminar esta asignación? No se puede deshacer",
    addTitle: "Agregar asignación de juego de ruta B",
    editTitle: "Editar asignación de juego de ruta B",
    selectAPlatformFirst: "Primero seleccione una plataforma de ruta A",
    aPlatformRequired: "Seleccione el código de plataforma de ruta A",
    aGameRequired: "Seleccione el código de juego de ruta A",
    bPlatformRequired: "Seleccione el código de plataforma de ruta B",
    bPlatformPh: "Seleccione el código de plataforma de ruta B",
    bGameCodeHint: "Opcional (juego de lobby; si está vacío, mantiene el código de juego original en la plataforma B)",
    col: {
      aPlatformCode: "Código de plataforma de ruta A",
      aGameCode: "Código de juego de ruta A",
      bPlatformCode: "Código de plataforma de ruta B",
      bGameCode: "Código de juego de ruta B",
      status: "Estado",
      createTime: "Creado en",
      action: "Acción"
    },
    status: { enabled: "Habilitado", disabled: "Deshabilitado" },
    btn: { search: "Buscar", reset: "Restablecer", add: "Agregar asignación", edit: "Editar", delete: "Eliminar", enable: "Habilitar", disable: "Deshabilitar" }
  },
  common: {
    button: {
      save: "Guardar",
      back: "Atrás",
      add: "Agregar",
      edit: "Editar",
      delete: "Eliminar"
    },
    queryFrm: {
      search: "Buscar",
      reset: "Restablecer"
    }
  },
  smsSupplyMgmt: {
    title: "Proveedor de Servicio SMS",
    countryName: "Nombre del País",
    countryCode: "Código de País",
    smsSupplyName: "Proveedor de Servicio SMS",
    operation: "Operación",
    enable: "Activado",
    disable: "Desactivado",
    confirmOperation: "Confirmar Operación",
    enableAction: "Habilitar",
    disableAction: "Deshabilitar",
    confirmEnable: "¿Está seguro de habilitar el proveedor de servicio SMS?",
    confirmDisable: "¿Está seguro de deshabilitar el proveedor de servicio SMS?",
    enableSuccess: "Habilitación Exitosa",
    disableSuccess: "Deshabilitación Exitosa",
    enableFailed: "Error al Habilitar",
    disableFailed: "Error al Deshabilitar",
    fetchDataFailed: "Error al Recuperar Datos",
    fetchCountryDataFailed: "Error al Recuperar Datos de País",
    loading: "Cargando...",
    unknown: "Desconocido",
    bottomTip: "Solo un proveedor de servicio SMS por país",
    paginationTotal: "Total {{total}} registros, mostrando {{start}}-{{end}}"
  },
  gameEntryMgmt: {
    customCategoryManagement: "Gestión de Categorías Personalizadas",
    gamePlatformManagement: "Gestión de Plataformas de Juego",
    gameLine: "Línea de Juego",
    customGameType: "Tipo de Juego Personalizado",
    systemPlatformCategory: "Categoría de Plataforma del Sistema",
    currency: "Moneda",
    isEnabled: "Habilitado",
    gamePlatformName: "Nombre de Plataforma de Juego",
    isMaintenance: "Mantenimiento",
    yes: "Sí",
    no: "No",
    operation: "Operación",
    add: "Agregar",
    edit: "Editar",
    delete: "Eliminar",
    enable: "Habilitar",
    disable: "Deshabilitar",
    maintenance: "Mantenimiento",
    refresh: "Actualizar",
    sort: "Ordenar",
    selectGameLine: "Seleccione la línea de juego",
    selectCurrency: "Seleccione la moneda",
    selectStatus: "Seleccione el estado",
    selectMaintenanceStatus: "Seleccione el estado de mantenimiento",
    pleaseInputSort: "Ingrese el ordenamiento",
    selectCustomGameCategory: "Seleccione la categoría de juego personalizada",
    selectGamePlatformCategory: "Seleccione la categoría de plataforma de juego",
    operationSuccess: "Operación exitosa",
    operationFailed: "Operación fallida",
    confirmMessage: "Confirmar eliminación",
    confirmDisable: "Confirmar deshabilitación",
    confirmEnable: "Confirmar habilitación",
    refreshSuccess: "Actualización exitosa",
    dataLoadFailed: "Error al cargar datos"
  },
  gameHotMgmt: {
    hotGameList: "Lista de Juegos Populares",
    hotGameLangList: "Lista de Idiomas de Juegos Populares",
    displayMethod: "Método de Visualización",
    platformName: "Nombre de Plataforma",
    gameName: "Nombre del Juego",
    gameLine: "Línea de Juego",
    currency: "Moneda",
    sort: "Ordenar",
    manualSort: "Ordenamiento Manual",
    autoSort: "Ordenamiento Automático",
    isEnabled: "Habilitado",
    yes: "Sí",
    no: "No",
    confirmDisable: "Confirmar Deshabilitación",
    confirmEnable: "Confirmar Habilitación",
    confirmDelete: "Confirmar Eliminación",
    operationSuccess: "Operación Exitosa",
    operationFailed: "Operación Fallida",
    dataLoadFailed: "Error al Cargar Datos",
    add: "Agregar",
    edit: "Editar",
    hotGame: "Juego Popular",
    language: "Idioma",
    entryImage: "Imagen de Entrada",
    uploadEntryImage: "Imagen de Entrada No Cargada",
    gamePlatform: "Plataforma de Juego",
    game: "Juego",
    customGameCategory: "Categoría de Juego Personalizada",
    pleaseSelectDisplayMethod: "Seleccione el Método de Visualización",
    pleaseSelectLine: "Seleccione la Línea",
    pleaseSelectCustomGameCategory: "Seleccione la Categoría de Juego Personalizada",
    pleaseSelectGamePlatform: "Seleccione la Plataforma de Juego",
    pleaseSelectGame: "Seleccione el Juego",
    pleaseInputSort: "Ingrese el Ordenamiento",
    pleaseSelectLanguage: "Seleccione el Idioma",
    pleaseSelectHotGame: "Seleccione el Juego Popular",
    pleaseSelectStatus: "Seleccione el Estado",
    pleaseInputGameName: "Ingrese el Nombre del Juego",
    pleaseInputPlatformName: "Ingrese el Nombre de Plataforma",
    setMultiLanguage: "Establecer Múltiples Idiomas",
    formValidationFailed: "Validación del Formulario Fallida",
    addSuccess: "Agregación Exitosa",
    editSuccess: "Edición Exitosa",
    icon: "Icono",
    status: "Estado",
    enabled: "Habilitado",
    disabled: "Deshabilitado",
    pleaseSelectCurrency: "Seleccione la Moneda"
  },
  gameListMgmt: {
    gameMainData: "Datos Principales del Juego",
    gameLangData: "Datos de Idioma",
    platformCategory: "Categoría de Plataforma",
    gamePlatform: "Plataforma de Juego",
    gameName: "Nombre del Juego",
    gameCode: "Código del Juego",
    sort: "Ordenar",
    manualSort: "Ordenamiento Manual",
    autoSort: "Ordenamiento Automático",
    effectMode: "Modo de Efecto",
    isPcSupported: "Compatibilidad con PC",
    isH5Supported: "Compatibilidad con H5",
    displayName: "Nombre de Visualización",
    gameEntryIcon: "Icono de Entrada del Juego",
    batchAdd: "Agregación en Lote",
    save: "Guardar",
    back: "Atrás",
    setMultiLanguage: "Establecer Múltiples Idiomas",
    addGameLangData: "Agregar Datos de Idioma del Juego",
    editGameLangData: "Editar Datos de Idioma del Juego",
    gameSystemName: "Nombre del Sistema de Juego",
    language: "Idioma",
    confirmDelete: "Confirmar Eliminación",
    confirmEnable: "Confirmar Habilitación",
    confirmDisable: "Confirmar Deshabilitación",
    pleaseSelectCategory: "Seleccione la Categoría",
    pleaseSelectPlatform: "Seleccione la Plataforma",
    pleaseInputGameName: "Ingrese el Nombre del Juego",
    pleaseInputGameCode: "Ingrese el Código del Juego",
    pleaseInputSort: "Ingrese el Ordenamiento",
    pleaseSelectPcSupport: "Seleccione la Compatibilidad con PC",
    pleaseSelectH5Support: "Seleccione la Compatibilidad con H5",
    pleaseInputDisplayName: "Ingrese el Nombre de Visualización",
    pleaseSelectLanguage: "Seleccione el Idioma",
    addSuccess: "Agregación Exitosa",
    editSuccess: "Edición Exitosa",
    formValidationFailed: "Validación del Formulario Fallida",
    dataLoadFailed: "Error al Cargar Datos",
    operationSuccess: "Operación Exitosa",
    operationFailed: "Operación Fallida",
    uploadImgStatus: "estado de imagen",
    pleaseSelectIsUploadImg: "todos",
    uploadImage: "cargado",
    noUploadImage: "no cargado",
    highRiskGame: "Juego de Alto Riesgo",
    highRiskConfig: "Juego de Alto Riesgo",
    highRiskNo: "No",
    highRiskYes: "Sí",
    highRiskFilterAll: "Todos",
    tagImg: "Etiqueta de Juego",
    tagImgHint: "64 × 40 px, máximo 50 KB",
    notConfigured: "No Configurado",
    h5Image: "Imagen H5 (Móvil)",
    pcImage: "Imagen PC (Quiosco / Escritorio)",
    h5ImageHint: "Utilizado por cliente H5 móvil",
    pcImageHint: "Utilizado por quiosco offline / cliente PC",
    missingH5: "Sin H5 (Móvil)",
    missingPc: "Sin PC (Quiosco)",
    imgStatusAll: "Todos",
    imgStatusH5Only: "Solo H5 (sin Quiosco)",
    imgStatusPcOnly: "Solo PC (sin Móvil)",
    imgStatusBoth: "Ambos",
    imgStatusNone: "Ninguno",
    currency: "Moneda",
    pleaseSelectCurrency: "Seleccione la moneda"
  },
  gamePlatformMgmt: {
    mainData: "Datos Principales de Plataforma",
    languageData: "Datos de Idioma",
    currencyData: "Datos de Moneda",
    platformName: "Nombre de Plataforma",
    platformKey: "Clave de Plataforma",
    platformType: "Tipo de Plataforma",
    platformCategory: "Categoría de Plataforma",
    platform: "Plataforma",
    platformDisplayName: "Nombre de Visualización de Plataforma",
    platformDesc: "Descripción de Plataforma",
    platformMaintainNotice: "Aviso de Mantenimiento",
    platformLogo: "Logotipo de Plataforma",
    platformEntryIcon: "Icono de Entrada de Plataforma",
    language: "Idioma",
    currency: "Moneda",
    displayName: "Nombre de Visualización",
    addPlatformLangData: "Agregar Datos de Idioma de Plataforma",
    setMultiLanguage: "Establecer Múltiples Idiomas",
    pleaseInputPlatformName: "Ingrese el nombre de plataforma",
    pleaseInputPlatformKey: "Ingrese la clave de plataforma",
    pleaseSelectPlatformType: "Seleccione el tipo de plataforma",
    pleaseSelectPlatformCategory: "Seleccione la categoría de plataforma",
    pleaseSelectPlatform: "Seleccione la plataforma",
    pleaseInputDisplayName: "Ingrese el nombre de visualización",
    pleaseInputPlatformDesc: "Ingrese la descripción de plataforma",
    pleaseInputMaintainNotice: "Ingrese el aviso de mantenimiento",
    pleaseSelectLanguage: "Seleccione el idioma",
    pleaseSelectCurrency: "Seleccione la moneda",
    dataLoadFailed: "Error al cargar datos",
    formValidationFailed: "Validación del formulario fallida",
    addSuccess: "Agregación exitosa",
    editSuccess: "Edición exitosa",
    operationSuccess: "Operación exitosa",
    operationFailed: "Operación fallida",
    confirmDeletePlatform: "Confirmar eliminación de plataforma",
    confirmDeletePlatformCurrency: "Confirmar eliminación de moneda de plataforma",
    platformCurrency: "Moneda de Plataforma",
    column: {
      title: {
        index: "Índice",
        gamePlatformName: "Nombre de Plataforma",
        gamePlatformCode: "Código de Plataforma",
        bRouteCode: "Código de Plataforma de Ruta B",
        gameType: "Tipo de Plataforma",
        desc: "Descripción",
        gameFullName: "Nombre Completo de Plataforma",
        gameShowName: "Nombre de Visualización",
        action: "Acción",
        platformName: "Nombre de Plataforma",
        platformType: "Tipo de Plataforma",
        currency: "Moneda"
      }
    }
  },
  // Mapa de nombres de línea de juego (el backend solo guarda nombres en chino; la clave es el nombre original)
  gameLineName: {
    "美国": "Estados Unidos",
    "墨西哥": "México",
    "菲律宾": "Filipinas"
  },
  // Mapa de categorías de juego (dict 31004/31005 solo guardan nombres en chino)
  gameCategoryName: {
    "电子": "Tragamonedas",
    "真人": "Casino en vivo",
    "体育": "Apuestas deportivas",
    "彩票": "Lotería",
    "捕鱼": "Pesca",
    "棋牌": "Cartas y tablero",
    "电竞": "Esports",
    "小游戏": "Minijuegos",
    "竞猜": "Predicción",
    "街机": "Máquina arcade",
    "宾果": "Bingo"
  },
  gamePromotMgmt: {
    mainPromotGamePlatform: "Plataforma de Juego Principal Promocionada",
    entryImage: "Imagen de Entrada",
    platform: "Plataforma",
    gamePlatform: "Plataforma de Juego",
    currency: "Moneda",
    sort: "Ordenar",
    status: "Estado",
    enabled: "Habilitado",
    disabled: "Deshabilitado",
    add: "Agregar",
    edit: "Editar",
    delete: "Eliminar",
    confirmDelete: "Confirmar Eliminación",
    confirmDisable: "Confirmar Deshabilitación",
    confirmEnable: "Confirmar Habilitación",
    addSuccess: "Agregación Exitosa",
    editSuccess: "Edición Exitosa",
    operationSuccess: "Operación Exitosa",
    operationFailed: "Operación Fallida",
    dataLoadFailed: "Error al Cargar Datos",
    formValidationFailed: "Validación del Formulario Fallida",
    pleaseSelectPlatform: "Seleccione la Plataforma",
    pleaseSelectGamePlatform: "Seleccione la Plataforma de Juego",
    pleaseInputSort: "Ingrese el Ordenamiento",
    pleaseSelectCurrency: "Seleccione la Moneda",
    pleaseSelectStatus: "Seleccione el Estado",
    column: {
      title: {
        index: "Índice",
        platformName: "Nombre de Plataforma",
        gamePlatformName: "Nombre de Plataforma de Juego",
        gameLine: "Línea de Juego",
        currency: "Moneda",
        sort: "Ordenar",
        status: "Estado",
        action: "Acción"
      }
    }
  },
  gameRecMgmt: {
    mainGameList: "Lista de Juego Principal",
    mainGameLangList: "Lista de Idiomas de Juego Principal",
    displayMethod: "Método de Visualización",
    platformName: "Nombre de Plataforma",
    gameName: "Nombre del Juego",
    gameLine: "Línea de Juego",
    currency: "Moneda",
    sort: "Ordenar",
    manualSort: "Ordenamiento Manual",
    autoSort: "Ordenamiento Automático",
    status: "Estado",
    enabled: "Habilitado",
    disabled: "Deshabilitado",
    add: "Agregar",
    edit: "Editar",
    delete: "Eliminar",
    confirmDelete: "Confirmar Eliminación",
    confirmDisable: "Confirmar Deshabilitación",
    confirmEnable: "Confirmar Habilitación",
    addSuccess: "Agregación Exitosa",
    editSuccess: "Edición Exitosa",
    operationSuccess: "Operación Exitosa",
    operationFailed: "Operación Fallida",
    dataLoadFailed: "Error al Cargar Datos",
    formValidationFailed: "Validación del Formulario Fallida",
    pleaseSelectPlatform: "Seleccione la Plataforma",
    pleaseSelectGamePlatform: "Seleccione la Plataforma de Juego",
    pleaseInputSort: "Ingrese el Ordenamiento",
    pleaseSelectCurrency: "Seleccione la Moneda",
    pleaseSelectStatus: "Seleccione el Estado",
    pleaseSelectLanguage: "Seleccione el Idioma",
    pleaseSelectGame: "Seleccione el Juego",
    pleaseSelectCustomGameCategory: "Seleccione la Categoría de Juego Personalizada",
    entryImage: "Imagen de Entrada",
    uploadEntryImage: "Imagen de Entrada No Cargada",
    gamePlatform: "Plataforma de Juego",
    game: "Juego",
    customGameCategory: "Categoría de Juego Personalizada",
    language: "Idioma",
    setMultiLanguage: "Establecer Múltiples Idiomas",
    column: {
      title: {
        index: "Índice",
        platformName: "Nombre de Plataforma",
        gamePlatformName: "Nombre de Plataforma de Juego",
        gameName: "Nombre del Juego",
        gameLine: "Línea de Juego",
        currency: "Moneda",
        sort: "Ordenar",
        status: "Estado",
        action: "Acción",
        icon: "Icono",
        language: "Idioma"
      }
    }
  },
  gameTypeMgmt: {
    editType: "Editar Tipo",
    type: "Tipo",
    typeRequired: "Ingrese el Tipo",
    pleaseInputType: "Ingrese el Tipo",
    gamePlatform: "Plataforma de Juego",
    pleaseSelectGamePlatform: "Seleccione la Plataforma de Juego",
    icon: "Icono",
    uploadIconRequired: "Cargue el Icono",
    menuIcon: "Icono de Menú",
    updateSuccess: "Actualización Exitosa",
    updateFailed: "Error al Actualizar",
    language: "Idioma",
    pleaseSelectLanguage: "Seleccione el Idioma",
    yes: "Sí",
    no: "No",
    dataLoadFailed: "Error al Cargar Datos",
    operationSuccess: "Operación Exitosa",
    operationFailed: "Operación Fallida",
    column: {
      title: {
        index: "Índice",
        gameGroupName: "Nombre del Grupo de Juego",
        gameStatus: "Estado del Juego",
        operateAction: "Operación",
        language: "Idioma",
        icon: "Icono",
        menuIcon: "Icono de Menú"
      }
    }
  },
  gameModuleMgmt: {
    yes: "Sí",
    no: "No",
    pageTitle: "Gestión de Módulos de Cliente",
    line: "Línea",
    language: "Idioma",
    selectLine: "Seleccione la línea",
    selectLanguage: "Seleccione el idioma",
    clientTab: "Pestañas del Cliente",
    modulesCount: "{{count}} módulos",
    moduleListTitle: "Pestaña · Lista de Módulos (Total {{count}} módulos)",
    selectTabHint: "Seleccione la línea e idioma, luego haga clic en una Pestaña",
    systemLocked: "🔒 Módulo del Sistema (Solo lectura)",
    jumpToSource: "⚙ Ir al Menú de Origen",
    addModule: "+ Agregar Módulo",
    editModule: "Editar Módulo",
    configGame: "⚙ Configurar Juegos",
    back: "Atrás",
    confirmDelete: "¿Confirmar la eliminación de este módulo?",
    addSuccess: "Agregado exitosamente",
    editSuccess: "Actualizado exitosamente",
    deleteSuccess: "Eliminado exitosamente",
    platformOrTabRequired: "Seleccione una línea y una pestaña primero",
    manualSort: "Ordenamiento Manual",
    autoSort: "Ordenamiento Automático",
    autoSortRule: "Regla de Ordenamiento Automático",
    resetDate: "Fecha de Restablecimiento",
    resetTime: "Hora de Restablecimiento",
    daily: "Diario",
    weekly: "Semanal",
    column: {
      sort: "Ordenar",
      autoSortRule: "Regla de Ordenamiento Automático",
      icon: "Icono",
      label: "Etiqueta",
      name: "Nombre del Módulo",
      isSystem: "Es Sistema",
      status: "Estado",
      action: "Acción"
    },
    add: { title: "Agregar Módulo" },
    edit: { title: "Editar Módulo" },
    form: {
      sort: "Ordenar",
      sortRequired: "Ingrese el ordenamiento",
      sortMustBeInteger: "El ordenamiento debe ser un entero",
      moduleName: "Nombre del Módulo",
      moduleNameRequired: "Ingrese el nombre del módulo",
      iconUrl: "Icono del Módulo",
      iconUrlRequired: "Cargue el icono del módulo",
      gameLabelUrl: "Etiqueta de Juego",
      remark: "Comentario",
      remarkPlaceholder: "Reglas del módulo, fuente de datos, notas operativas (solo oficina)",
      langSelect: "Idiomas",
      langSelectRequired: "Seleccione los idiomas",
      langHint: "⚙ Nombre del Módulo / Icono / Etiqueta de Juego / Comentario se mantienen por idioma",
      displayRows: "Filas de visualización",
      displayRowsRequired: "Seleccione las filas de visualización",
      displayRows1: "1*3 (1 fila / 3 juegos)",
      displayRows2: "2*3 (2 filas / 6 juegos)",
      displayRows3: "3*3 (3 filas / 9 juegos)",
      displayRowsKiosk1: "1*7 (1 fila / 7 juegos)",
      displayRowsKiosk2: "2*7 (2 filas / 14 juegos)",
      displayRowsKiosk3: "3*7 (3 filas / 21 juegos)"
    },
    gameConfig: {
      module: "Módulo",
      attached: "Adjunto",
      attachedCount: "{{count}} juegos",
      addGame: "Agregar",
      batchRemove: "Eliminación en Lote",
      remove: "Eliminar",
      confirmRemove: "¿Confirmar la eliminación de este juego del módulo?",
      confirmBatchRemove: "¿Confirmar la eliminación de los {{count}} juegos seleccionados de este módulo?",
      removeSuccess: "Eliminado",
      selectAtLeastOne: "Seleccione al menos un juego"
    },
    gameAdd: {
      title: "Seleccione juegos de \"Configuración de Subjuego\" para adjuntar a este módulo",
      index: "Índice",
      gameType: "Categoría de Plataforma",
      gamePlatform: "Plataforma de Juego",
      gameName: "Nombre del Juego",
      gameNamePlaceholder: "Ingrese el nombre del juego",
      selectGameType: "Seleccione la categoría de plataforma",
      selectGamePlatform: "Seleccione la plataforma de juego",
      platformRequired: "Seleccione una plataforma de juego primero",
      selectAtLeastOne: "Marque al menos un juego",
      addSuccess: "Agregado exitosamente"
    }
  },
  desktopGameModuleMgmt: {
    pageTitle: "Gestión de Módulos de Escritorio",
    desktopTab: "Pestaña de Escritorio",
    copyFromClient: "Copiar desde Cliente",
    copyFromClientHint: "Los módulos de escritorio se almacenan independientemente de los módulos de cliente. Use copiar-desde-cliente para inicializar todos los grupos de la configuración de cliente existente.",
    copyFromClientConfirm: "¿Confirmar la copia de todos los grupos desde cliente? Los módulos del sistema se deduplicen por código; los módulos personalizados se copian solo para grupos que estén actualmente vacíos. No se sobrescriben datos existentes.",
    copyFromClientResult: "Copiados {{count}} módulo(s)",
    selectLineFirst: "Seleccione una línea primero"
  }
};
